// 🎨 Color → Family mapping (acts like a DB)
window.COLOR_FAMILY_MAP = {
  // Purple family
  'lavender': 'Purple',
  'plum': 'purple',
  'violet': 'Purple',
  'lilac': 'Purple',

  // Green family
  'light green': 'green',
  'mint': 'green',
  'sage': 'green',
  'olive': 'green',
  'Lime': 'green',
  'hunter':'green',
  'kiwi':'green',
  'turquoise':'green',
  'turq':'green',
  'forest':'green',
  'emerald':'green',

  // Blue family
  'navy': 'blue',
  'sky blue': 'blue',
  'jade':'blue',
  'turquoise':'blue',
  'teal':'blue',
  'royal':'blue',
   'denim':'blue',

  // Red family
  'burgundy': 'red',
  'wine': 'red',
  'rose':'red',

  //Brown family
  'rust':'brown',
  'taupe':'brown',
  'mauv':'red',
  'taupe':'brown',
  'mocha':'brown',

  //grey family
  'charcoal':'grey',
    'silver':'grey',


  //orange family
  'coral':'orange',

  //Beige family
'nude':'beige',
'oatmeal':'beige',
'wheat':'beige',


  // grey family
  'grey':'heather',
    'ivory':'grey',

// pink family
'magenta':"pink",
'blush':"pink",

  //yellow family
    'gold':'yellow',

  // Direct matches / fallbacks
  'pink': 'pink',
  'purple': 'purple',
  'dreen': 'green',
  'black': 'black',
  'blue': 'blue',
  'brown':'brown',
  'grey':'grey',
  'gray':'grey',
  'red':'red',
  'green':'green',
  'white':'white'



  
};
